export const queryBuilder = (eventIds) => `$filter=id in(${eventIds.map(id => `'${id}'`).join(",")})`;
//# sourceMappingURL=queryBuilder.js.map